import PackageInfo from '../../../../package.json';
import {
  DatadogClient,
  RumInitConfiguration,
  LogsInitConfiguration,
} from '@workivate/tho-web-shared';

const deploymentEnvironment = import.meta.env.DEPLOYMENT_ENVIRONMENT ?? '';
const commonDatadogConfig = {
  clientToken: import.meta.env.DD_CLIENT_TOKEN ?? '',
  env:
    deploymentEnvironment === 'production' // Use 'prod' instead of 'live' for DataDog environment to make it consistent with other environments,
      ? 'prod'
      : deploymentEnvironment,
  service: 'usl',
  version: `${PackageInfo.version}_${deploymentEnvironment}`, // This version must match with the version that is referenced in web_cicd.yml
};

const dataDogRUMConfig: RumInitConfiguration = {
  applicationId: import.meta.env.DD_APP_ID ?? '',
  ...commonDatadogConfig,
};

const dataDogLogsConfig: LogsInitConfiguration = {
  ...commonDatadogConfig,
};

export const initialiseDataDog = () => {
  DatadogClient.initDataDog(dataDogLogsConfig, dataDogRUMConfig);
};
